
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("./lib/d3-shape");



//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/d3-shape.js
// module id = ./node_modules/victory-vendor/d3-shape.js
// module chunks = 1